import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';

import { AppServices } from './../../app.services';
import { NotifyService } from './../../addon/notify.service';

import * as _ from 'lodash';
import * as dot from 'dot-object';
import * as mathjs from 'mathjs';
import * as domtoimage from 'dom-to-image';
declare var $:any;

@Component({
	selector: 'app-bill',
	templateUrl: './bill.component.html',
	styleUrls: ['./bill.component.css']
})
export class BillComponent implements OnInit {
	filter_summary = {};
	data_summary;
	filter_bill = {};
	data_bill; bill;
	data_rpt;
	constructor(private router: Router, private appServices: AppServices, private notifyService: NotifyService) { }

	ngOnInit() {
		this.loadSummary();
		this.loadRpt();
	}
	ngAfterViewChecked() {
		$('.text-justify img').addClass('img-fluid');
		$(document).on('focusin', function(e) {
			if ($(e.target).closest(".mce-window").length) {
				e.stopImmediatePropagation();
			}
		});
	}
	assign(frm, data) {
		$.each(data, function(key){
			frm[key] = data[key];
		})
	}

	loadSummary() {
		let filter = this.filter_bill;
		Object.assign(filter, {"deleted":false, "accountcode": this.appServices.accountcode, 'paid_dt': null})
		this.appServices.api('Crmbills/sum', {
			'filter': `{"where":${JSON.stringify(filter)}, "order": "updated_dt desc"}`,
			'prop': 'deadline',
			'type': 'date'
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.data_summary = res.map(el => {
				return Object.assign(el, {'status': new Date(el.deadline) < new Date() ? 'danger': 'warning'})
			});
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadBill(data) {
		this.data_bill = data.data;
	}
	saveBill(data) {
		data = _.pickBy(data);
		data['deleted'] = false;
		data['email'] = {
			'to': data['to'],
			'cc': data['cc']
		}
		data = dot.object(data);
		this.appServices.api('Crmbills/save', data, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.notifyService.show(obj.response.statusText)
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	payBill(data) {
		data['paid_dt'] = new Date();
		this.appServices.api('Crmbills/save', data, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.notifyService.show(obj.response.statusText)
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})	
	}
	loadRpt() {
		this.appServices.api('Hosreports/find', {
			'filter': `{"where":{"codeorg": "${this.appServices.appname}", "deleted":false}, "order":"created_dt desc"}`
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.data_rpt = res;
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	parsePrint(rpt, data, frm) {
		data['updated_dt'] = data['updated_dt'].substr(0, 10)
		data['deadline'] = data['deadline'].substr(0, 10)
		data['amount'] = data['amount'].toString();
		data['info']['billto'] = data['info']['billto'] ? data['info']['billto'] : '';
		data['info']['shipto'] = data['info']['shipto'] ? data['info']['shipto'] : '';
		data['info']['po'] = data['info']['po'] ? data['info']['po'] : '';
		data['info']['subtotal'] = data['info']['subtotal'] ? data['info']['subtotal'] : '';
		data['info']['tax'] = data['info']['tax'] ? data['info']['tax'] : '';
		frm['result'] = mathjs.print(rpt.template, data)
		this.bill = data;
	}
	doSend(data) {
		domtoimage.toPng(document.getElementById('print-template')).then((base64) => {
			this.appServices.api('Contacts/sendmail', {
				'to': [data.email.to],
				'cc': [data.email.cc],
				'subject': data.name,
				'content': `<img src="cid:bg">`,
				'files': [{
					"cid":"bg",
					"path": base64
				}]
			}, this).then(function(obj){
				let res = obj.response.json().res;
				obj.component.notifyService.show(obj.response.statusText)
			}).catch(function(err){
				err.component.notifyService.show(err.err.json().error.message, 'danger');
			})
		}).catch(function (err) {
			console.log(err)
		});
	}
}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/main/bill/bill.component.ts